var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun_note_585381",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.647,
    height: 76.774,
    viewBox: "0 0 74.647 76.774",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1589",
    "data-name": "Group 1589",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1588",
    "data-name": "Group 1588",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6382",
    "data-name": "Rectangle 6382",
    width: 3.42,
    height: 7.946,
    transform: "translate(4.543 29.845)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6383",
    "data-name": "Rectangle 6383",
    width: 3.42,
    height: 7.946,
    transform: "translate(4.543 44.187)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41903",
    "data-name": "Path 41903",
    d: "M26.967,40.6H23.535V28.609a6.3,6.3,0,0,1,6.3-6.288H72.657l-2.824,3.432h-40a2.865,2.865,0,0,0-2.868,2.868Z",
    transform: "translate(-18.998 -17.106)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41904",
    "data-name": "Path 41904",
    d: "M86.088,88.233v44.579a6.312,6.312,0,0,1-6.3,6.3H29.835a6.312,6.312,0,0,1-6.3-6.3V120.856h3.432v11.957a2.865,2.865,0,0,0,2.868,2.868H79.79a2.877,2.877,0,0,0,2.88-2.868V122.653h-.056v-5.575h.056V92.416Z",
    transform: "translate(-18.998 -62.338)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41905",
    "data-name": "Path 41905",
    d: "M17.8,174.17H10.536a1.479,1.479,0,1,0,0,2.958H17.8a2.9,2.9,0,1,0,0-2.958Z",
    transform: "translate(-9.057 -120.327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41906",
    "data-name": "Path 41906",
    d: "M17.763,128.484H10.5a1.488,1.488,0,0,0,0,2.973h7.265a2.9,2.9,0,1,0,0-2.973Z",
    transform: "translate(-9.019 -88.986)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41907",
    "data-name": "Path 41907",
    d: "M17.8,82.815H10.536a1.479,1.479,0,0,0,0,2.959H17.8a2.9,2.9,0,1,0,0-2.959Z",
    transform: "translate(-9.057 -57.642)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1587",
    "data-name": "Group 1587",
    transform: "translate(24.452)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1586",
    "data-name": "Group 1586",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41908",
    "data-name": "Path 41908",
    d: "M119.728,31.4l-1.462,1.731L93.484,63.47a6.517,6.517,0,0,0-.976,1.719c-1.731,4.552-3.412,9.1-5.1,13.614a5.333,5.333,0,0,0-.36,1.462,1.851,1.851,0,0,0,1.582,2.1,2.134,2.134,0,0,0,.988-.1,6.574,6.574,0,0,0,1.386-.693l2.274-1.409q4.064-2.505,8.1-5.058l.36-.222a13.2,13.2,0,0,0,3.45-2.795q8.408-10.32,16.824-20.616L130.562,41c.123-.134.234-.26.345-.395ZM100.992,71.027c-1.693,1.064-3.388,2.128-5.084,3.216-.383.222-.617.222-.9-.023-.395-.371-.842-.693-1.225-1.064a.514.514,0,0,1-.134-.506c.792-2.175,1.6-4.33,2.412-6.5a1.026,1.026,0,0,1,.1-.149c1.842,1.52,3.672,3.029,5.555,4.575C101.5,70.717,101.261,70.866,100.992,71.027Z",
    transform: "translate(-87.033 -23.332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41909",
    "data-name": "Path 41909",
    d: "M211.8,10.843q-2.669-2.225-5.382-4.385a3.947,3.947,0,0,0-5.63.912c-.772.924-1.517,1.851-2.277,2.777l-.623.751c-.047.07-.108.152-.158.222l-.058-.047.821.669.243.2,9.261,7.537.985.792.909-1.1c.713-.877,1.427-1.734,2.128-2.631a3.923,3.923,0,0,0-.219-5.7Z",
    transform: "translate(-162.941 -5.66)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteIcon);
export default __webpack_public_path__ + "static/media/note-icon.86708b446ccc10607244a08995daa18c.svg";
export { ForwardRef as ReactComponent };